import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { MENU_INFO_ROUTES } from './routes';
import { MenuDetailScreen } from '@/screens/menu/menu-detail-screen';
import { MenuInfoContextProvider } from '@/contexts/menu-info-context';
import { MenuItemDetailScreen } from '@/screens/menu/menu-item-detail-screen';
import { MenuItemSearchScreen } from '@/screens/menu/menu-item-search-screen';
import { MenuStackParams } from './types';
import { SplitMenuDetailScreen } from '@/screens/menu/split-menu-detail-screen';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';
import { useLayoutContext } from '@/contexts/layout-context';

const Stack = createStackNavigator<MenuStackParams>();

export const MenuInfoStack: React.FC = () => {
  const screenOptions = useDefaultAppTabScreenOptions('screen');
  const { isSmallLayout } = useLayoutContext();

  return (
    <MenuInfoContextProvider>
      <Stack.Navigator
        initialRouteName={MENU_INFO_ROUTES.Base}
        screenOptions={screenOptions}
      >
        <Stack.Screen
          component={isSmallLayout ? MenuDetailScreen : SplitMenuDetailScreen}
          name={MENU_INFO_ROUTES.Base}
        />
        <Stack.Screen
          component={MenuItemDetailScreen}
          name={MENU_INFO_ROUTES.ItemDetail}
        />
        <Stack.Screen
          component={MenuItemSearchScreen}
          name={MENU_INFO_ROUTES.Search}
        />
      </Stack.Navigator>
    </MenuInfoContextProvider>
  );
};
